import { render, staticRenderFns } from "./BankOtpActivity.vue?vue&type=template&id=6d094522&scoped=true&"
import script from "./BankOtpActivity.vue?vue&type=script&lang=js&"
export * from "./BankOtpActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=6d094522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d094522",
  null
  
)

export default component.exports